import { render, staticRenderFns } from "./communityArticle.vue?vue&type=template&id=006d032d&scoped=true"
import script from "./communityArticle.vue?vue&type=script&lang=js"
export * from "./communityArticle.vue?vue&type=script&lang=js"
import style0 from "./communityArticle.vue?vue&type=style&index=0&id=006d032d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d032d",
  null
  
)

export default component.exports